<template>
  <v-layout column>
    <v-flex xs12>
      <h3>Search Promotions</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-text-field v-model="query.search" label="Search"></v-text-field>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
    <v-layout pt-3 pb-3 column>
      <v-divider />
    </v-layout>
    <v-layout column>
      <router-link to="/settings/promotions/create">
        <h4>Create Promotion</h4>
      </router-link>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "promotions_search_box",
  props: {
    query: Object
  },
  data: function() {
    return {};
  },
  methods: {
    fromChanged: function(d) {
      this.query.after = d;
    },
    toChanged: function(d) {
      this.query.before = d;
    },
    search: function() {
      this.$emit("search");
    },
    clear: function() {
      this.$emit("clear");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
